<template>
  <Layout>
    <div class="driver-main">

      <b-tabs nav-class="nav-tabs-custom"
              content-class="tab-content-zone text-muted"
              :class="{'nav-justified':$store.state.layout.browserMode === 'mobile'}">
        <template v-for="(tab, i) in tabs">
          <b-tab :key="`tab-${i}`" :active="i === 1">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i :class="`mdi ${tab.icon}`" />
              </span>
              <span class="d-none d-sm-inline-block">
                <i :class="`mdi ${tab.icon} icon-padding-right`" />
              </span>
              <span class="d-none d-sm-inline-block">{{ tab.title }}</span>
            </template>
<!--            <keep-alive>-->
              <component :is="tab.component" :key="i" />
<!--            </keep-alive>-->
          </b-tab>
        </template>
      </b-tabs>

    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main.vue';
import RecommendStatus from '@/views/pages/driver/recommendStatus.vue';
import RecommendInfo from '@/views/pages/driver/recommendInfo.vue';
import Recommend from "@/views/pages/driver/recommend.vue";

export default {
  components: { Layout, RecommendStatus, RecommendInfo, Recommend },
  data() {
    return {
      tabs: [
        // { title: '추천 서비스 현황', icon: 'mdi-clipboard-text-multiple', component: 'RecommendStatus' },
        // { title: '추천 정보', icon: 'mdi-car-info', component: 'RecommendInfo' },
        { title: '운전자 추천 서비스', icon: 'mdi-car-info', component: 'Recommend' }
      ]
    }
  }
}
</script>
